import { render, staticRenderFns } from "./PrivacyScreen.vue?vue&type=template&id=5c026f72&"
import script from "./PrivacyScreen.vue?vue&type=script&lang=js&"
export * from "./PrivacyScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports